"use strict";
var hasOwn = require("../internals/has-own-property");
module.exports = function(descriptor) {
  return descriptor !== void 0 && (hasOwn(descriptor, "value") || hasOwn(descriptor, "writable"));
};
